/**
 * Normalize an entity id for persistence / API payloads.
 * Optimistic tree placeholders use ids like `fake-…` / `fake-category-…`
 * and must not be sent to integer columns or route params.
 *
 * @param {unknown} id
 * @returns {number|null}
 */
export function toPersistedEntityId(id) {
    if (id == null || id === "") {
        return null;
    }

    if (typeof id === "string" && id.startsWith("fake")) {
        return null;
    }

    const numeric = Number(id);

    if (!Number.isFinite(numeric) || numeric <= 0) {
        return null;
    }

    return numeric;
}
